/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Sep 08, 2016
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");
var xtend = require("xtend");
// TODO: Be more smart with added and removed events

/**
 * Keeps track of the user list, and the users' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedusers",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers,

	_users: null, // The array of user ids
	_people: null,
	_contacts: null,
	_group: null,

	reset: reset,
	refresh: refresh,
	processUsers: processUsers,
	recalculate: recalculate
});

/**
 * Adds listeners for changes in the user list, changes in the people store, and fetches the initial state
 * @return {Promise} Resolves to the initial state
 */
function init() {
	this._users = [];
	this._contacts = [];
	this._people = {};
	this._group = "";
	this._page = 0;
	this._query = null;
	this._tracker = this.dispatcher.createTracker();

	this.refresh();

	this.push([]);
}

/**
 * Clears extra data
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._page = 0;
	this._query = null;
	this._users = null;
	this._tracker.off();
	this._tracker = null;
}

function triggers() {
	return {
		"group:load": load_group,
		"group:clear": clear_group,
		"search": search,
		"more": load_more
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_updated,
		"contacts:updated": handle_contacts_updated,
	};
}

function recalculate() {
	var people = this._people;
	var users = this._users;
	var contacts = this._contacts;

	this.push(users.reduce(function (list, id) {
		var person = people[id];
		if (!person)
			return list;

		if (personIn(id, contacts))
			person = xtend(person, {
				isContact: true
			});

		list.push(person);
		return list;
	}, []));
}

function load_group({group}) {
	this._group = group;
	this.refresh();
	this.emit("usermetrics:trigger:track", "filter by group in managed users list", {
		group,
	});
}

function clear_group() {
	this.emit("usermetrics:trigger:track", "clear group filter in managed users list", {
		from: this._group,
	});
	this._group = null;
	this.refresh();
}

function handle_added(data) {
	var id = data.person;
	if (this._users.indexOf(id) !== -1) return;
	this._users.push(id);
	this.recalculate();
	this.emit("people:trigger:add", {
		lean: true,
		who: [id]
	});
}

function handle_removed(data) {
	var id = data.person;
	var oldSize = this._users.length;

	this._users = this._users.filter(function (existing) {
		return existing !== id;
	});

	if (this._users.length !== oldSize) this.recalculate();
}

/**
 * Processes the map of all people and returns an array of just the users' data
 * @param  {Object} people Map of id-userdata
 * @return {Array}        Array of all users' data
 */
function handle_people_updated(people) {
	this._people = people;
	this.recalculate();
}

/**
 * Refreshes the user list and adds all users to be watched by the people store
 * @return {Promise} Resolves when everything is refreshed and passed to people store
 */
function refresh() {
	this.reset();
	return this.api.manage.list(this._group, this._page, this._query) // Get the users list
		.then(set_users.bind(this)) // Set _users on the store
		.then(track_people.bind(this))
		.then(track_changes.bind(this)); // Add all users to people store
}

/**
 * Tells people model to start tracking ids. Triggers a people update
 * @param  {Array} who Array of ids to track
 */
function track_people(who) {
	this.emit("people:trigger:add", {
		lean: true,
		who: who
	});
}

/**
 * Really kinda self-explanatory
 */
function set_users(users) {
	this._users = users;
	return this.processUsers(users);
}

function handle_contacts_updated(contacts) {
	this._contacts = contacts;
	this.recalculate();
}

function personIn(person, list) {
	return list.some(function (item) {
		var other = item._id || item;
		return other === person;
	});
}

function track_changes(){
	var group = this._group;
	var tracker = this._tracker;

	tracker.off();

	if(group){
		tracker.on(`mqtt:managegroup/${group}/patient/added`, handle_added.bind(this));
		tracker.on(`mqtt:managegroup/${group}/patient/removed`, handle_removed.bind(this));
	} else {
		tracker.on("mqtt:$/manage/added", handle_added.bind(this));
		tracker.on("mqtt:$/manage/removed", handle_removed.bind(this));
	}
}

function load_more(){
	this._page++;
	this.emit("usermetrics:trigger:track", "load more managed users");
	return this.api.manage.list(this._group, this._page, this._query)
		.then(add_users.bind(this));
}

function add_users(users){
	var current = this._users;
	var newUsers = current.concat(users);
	this._users = newUsers;
	this.processUsers(users);
}

function search(data){
	var query = data.search;
	this._query = query;

	if(query) this.emit("managedusersend:trigger:search");
	else this.emit("managedusersend:trigger:search:end");

	this.emit("usermetrics:trigger:track", query ? "search managed users" : "clear managed users search");

	this.reset();
	return this.api.manage.list(this._group, this._page, this._query)
		.then(set_users.bind(this));
}

function reset(){
	this._page = 0;
	this.emit("managedusersend:trigger:end", false);
}

function processUsers(fetched){
	var fullUsers = this._users;

	if(fetched.length < 32)
		this.emit("managedusersend:trigger:end", true);

	this.emit("people:trigger:add", {
		lean: true,
		who: fullUsers
	});

	this.recalculate();
	return fullUsers;
}